import { Api } from '../services/api';

export class Environment {
  api: Api;
}
